import {NgModule} from '@angular/core';
import {ChipComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgForOf, NgIf, NgStyle} from '@angular/common';
import {IconComponentModule} from '../icon/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgForOf,
        NgIf,
        IconComponentModule,
        NgStyle
    ],
  exports: [
    ChipComponent
  ],
  declarations: [ChipComponent],
  providers: [],
})
export class ChipComponentModule {
}
